module.exports = __webpack_public_path__ + "img/856.95372cfa.png";